<template>
  <span class="info-line-value" v-if="!checkUrlInStr(field.value)">{{ customFieldValue(field) }}</span>
  <span class="info-line-value" v-else>
    <template v-for="text in field.value.split(oneOrMoreSpaces)" >
        <template v-if="!checkUrlInStr(text)">{{text}}</template>
        <a target="_blank" v-else :href="text | AddExternalLinkPrefix">{{text}} </a>
    </template>
  </span>
</template>

<script>
import {stringUtil, urlUtil} from "@/modules/common/utils";
import moment from "moment";
export default {
  name: "CustomField",
  props: {
    field: {
      type: Object,
      required: true,
    }
  },
  methods: {
    customFieldValue(field) {
      if (field.type === 'checkbox' && typeof field.value === 'boolean') {
        return this.$t(this.$options.filters.yesNoValue(field.value));
      } else if (field.type === 'datepicker' && field.value && stringUtil.isTimestamp(field.value)) {
        if(field.object_type === 'contact') return moment(field.value).locale(this.$store.getters.lang).format('ll'); // temporary fix until BE unify all dates
        return moment(field.value).utc().locale(this.$store.getters.lang).format('ll');
      }
      return field.value;
    },
    checkUrlInStr(str) {
      return urlUtil.isUrlInStr(str);
    },
  },
  created() {
    this.oneOrMoreSpaces = /(\S+\s+)/;
  }
}
</script>

<style lang="scss" scoped>

.info-line-value {
  white-space: pre-wrap;
}

</style>
